import { render, staticRenderFns } from "./RiskDist.vue?vue&type=template&id=279dcc9a&scoped=true"
import script from "./RiskDist.vue?vue&type=script&lang=js"
export * from "./RiskDist.vue?vue&type=script&lang=js"
import style0 from "./RiskDist.vue?vue&type=style&index=0&id=279dcc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279dcc9a",
  null
  
)

export default component.exports